const fr = {
  common: {
    loading: "Chargement...",
    back: "Retour",
    next: "Suivant",
    save: "Enregistrer",
    cancel: "Annuler",
    close: "Fermer",
    send: "Envoyer",
    submit: "Soumettre",
    yes: "Oui",
    no: "Non",
    error: "Erreur",
    success: "Succ\u00E8s",
    search: "Rechercher",
    more: "Plus",
    less: "Moins",
    optional: "optionnel",
    required: "Obligatoire",
    perMonth: "/ mois",
    oneTime: "unique",
    free: "Gratuit",
    skip: "Passer",
    pleaseWait: "Veuillez patienter...",
    backToHome: "Retour \u00E0 l'accueil",
    learnMore: "En savoir plus",
    email: "E-mail",
    phone: "T\u00E9l\u00E9phone",
    password: "Mot de passe",
    name: "Nom",
    selected: "s\u00E9lectionn\u00E9",
    available: "disponible",
    used: "utilis\u00E9",
    of: "de",
    question: "Question",
    craftBusiness: "Entreprise artisanale",
    forCraftBusinesses: "Pour les entreprises artisanales",
    projectInquiry: "Demande de projet",
    projectInquiries: "Demandes de projets",
  },
  header: {
    dashboard: "Tableau de bord",
    signOut: "Se d\u00E9connecter",
    completeProfile: "Compl\u00E9ter le profil",
    submitInquiry: "Soumettre une demande",
    signIn: "Se connecter",
    menuOpen: "Ouvrir le menu",
    menuClose: "Fermer le menu",
    registerAsCraft: "S'inscrire comme entreprise artisanale",
  },
  footer: {
    tagline: "Demandes de projets qualifi\u00E9es.\nPour des entreprises artisanales s\u00E9lectionn\u00E9es.",
    motto: "Trouver \u00B7 Connecter \u00B7 Construire",
    platform: "Plateforme",
    findCraft: "Trouver un artisan",
    submitInquiry: "Soumettre une demande",
    forCraftBusinesses: "Pour les entreprises artisanales",
    aboutUs: "\u00C0 propos",
    legalAndContact: "L\u00E9gal & Contact",
    imprint: "Mentions l\u00E9gales",
    privacy: "Confidentialit\u00E9",
    accessibility: "Accessibilit\u00E9",
    contact: "Contact",
    copyright: "\u00A9 {{year}} CRAFTFINDUS. Pour les entreprises artisanales en Allemagne, Autriche et Suisse.",
  },
  cookies: {
    title: "Nous utilisons des cookies",
    description: "Nous utilisons des cookies pour vous offrir la meilleure exp\u00E9rience possible. Plus d'informations dans notre",
    privacyLink: "Politique de confidentialit\u00E9",
    acceptAll: "Tout accepter",
    configure: "Configurer",
    saveSelection: "Enregistrer la s\u00E9lection",
    onlyNecessary: "Uniquement n\u00E9cessaires",
    necessary: "N\u00E9cessaire",
    necessaryDesc: "Requis pour le fonctionnement du site.",
    analytics: "Analyse",
    analyticsDesc: "Nous aident \u00E0 comprendre l'utilisation du site.",
    marketing: "Marketing",
    marketingDesc: "Permettent la publicit\u00E9 personnalis\u00E9e.",
  },
  mobileCta: {
    submitInquiry: "Soumettre une demande",
    craftBusiness: "Entreprise artisanale",
  },
  floatingPhone: {
    question: "Des questions ? Appelez-nous :",
    ariaLabel: "Afficher le num\u00E9ro de t\u00E9l\u00E9phone",
  },
  home: {
    seoTitle: "Trouver un artisan & recevoir des demandes de projets",
    seoDesc: "CRAFTFINDUS : Trouvez gratuitement le bon artisan ou recevez des demandes de projets qualifi\u00E9es. Matching intelligent, 3 \u00E0 5 entreprises par projet.",
    heroLabel: "La plateforme artisanale pour votre projet",
    heroTitle1: "Trouver le bon",
    heroTitle2: "artisan.",
    heroTitle3: "Sans recherche interminable.",
    heroDesc: "D\u00E9crivez votre projet. Nous trouvons 3 \u00E0 5 entreprises artisanales pour vous. Gratuit, en moins de 24 heures.",
    heroCta: "Trouver un artisan gratuitement",
    heroCtaCraft: "Je suis une entreprise artisanale",
    badge100Free: "100% gratuit",
    badgeResponse: "R\u00E9ponse en <24h",
    badgeVerified: "Entreprises v\u00E9rifi\u00E9es",
    tradesLabel: "Votre projet, notre r\u00E9seau",
    tradesTitle: "Trouvez le bon artisan pour chaque m\u00E9tier",
    tradesDesc: "Qu'il s'agisse de r\u00E9paration, de construction neuve ou de r\u00E9novation \u2013 {{brand}} trouve la bonne entreprise pr\u00E8s de chez vous.",
    tradesCta: "Trouver un artisan maintenant",
    electrician: "\u00C9lectricien",
    electricianDesc: "Installation \u00E9lectrique, \u00E9clairage, tableau \u00E9lectrique, maison connect\u00E9e \u2013 trouvez un \u00E9lectricien pr\u00E8s de chez vous.",
    plumbing: "Plomberie & Chauffage",
    plumbingDesc: "R\u00E9novation de salle de bain, remplacement de chauffage, tuyauterie \u2013 des installateurs professionnels.",
    roofing: "Couvreurs & Charpentiers",
    roofingDesc: "R\u00E9novation de toiture, lucarnes, charpente \u2013 des couvreurs exp\u00E9riment\u00E9s.",
    painting: "Peintres & Sols",
    paintingDesc: "Peinture de fa\u00E7ade, papier peint, rev\u00EAtements de sol \u2013 des artisans cr\u00E9atifs.",
    solar: "Photovolta\u00EFque & Climat",
    solarDesc: "Panneaux solaires, pompes \u00E0 chaleur, climatisation \u2013 des solutions \u00E9nerg\u00E9tiques durables.",
    construction: "Construction & Am\u00E9nagement",
    constructionDesc: "Placo, carrelage, r\u00E9novation compl\u00E8te \u2013 tout d'une seule main.",
    howLabel: "3 \u00E9tapes simples",
    howTitle: "Comment trouver le bon artisan",
    howDesc: "Pas de recherche interminable. Pas d'appels sans fin. Nous vous guidons.",
    step1Title: "D\u00E9crivez votre projet",
    step1Desc: "R\u00E9pondez \u00E0 quelques questions simples \u2013 p.ex. 'R\u00E9nover la salle de bain' ou 'Installer des panneaux solaires'.",
    step2Title: "Les artisans sont s\u00E9lectionn\u00E9s",
    step2Desc: "{{brand}} trouve automatiquement jusqu'\u00E0 5 entreprises qui correspondent \u00E0 votre projet. De votre r\u00E9gion, avec la bonne exp\u00E9rience.",
    step3Title: "Vous \u00EAtes contact\u00E9",
    step3Desc: "Les entreprises s\u00E9lectionn\u00E9es vous contactent directement, personnellement. Vous d\u00E9cidez qui convient le mieux.",
    benefitsLabel: "Avantages",
    benefitsTitle: "Une plateforme, deux gagnants",
    forClients: "Pour les clients",
    clientsTitle: "Trouver un artisan : simple & gratuit",
    clientFree: "Enti\u00E8rement gratuit",
    clientFreeDesc: "Aucun frais, aucune commission. Vous ne payez que votre artisan.",
    clientNoJargon: "Pas de jargon n\u00E9cessaire",
    clientNoJargonDesc: "D\u00E9crivez votre projet avec vos propres mots. Nous trouvons les bons m\u00E9tiers.",
    clientFast: "R\u00E9ponses rapides",
    clientFastDesc: "En moins de 24 heures, 3 \u00E0 5 entreprises vous contactent.",
    clientQuality: "Qualit\u00E9 v\u00E9rifi\u00E9e",
    clientQualityDesc: "Toutes les entreprises sont v\u00E9rifi\u00E9es. Les ma\u00EEtres artisans sont mis en avant.",
    clientCta: "Soumettre une demande gratuite",
    forProviders: "Pour les entreprises artisanales",
    providersTitle: "Demandes de projets qualifi\u00E9es, sans effort",
    providerMatched: "Projets correspondants",
    providerMatchedDesc: "Uniquement des demandes qui correspondent \u00E0 votre m\u00E9tier, r\u00E9gion et capacit\u00E9.",
    providerCompetitors: "Max. 3 \u00E0 5 concurrents",
    providerCompetitorsDesc: "Pas de plateforme de masse. Des chances \u00E9quitables.",
    providerTransparent: "Co\u00FBts transparents",
    providerTransparentDesc: "Un prix fixe par demande. Pas de frais mensuels, pas de commissions.",
    providerRate: "Taux d'acceptation \u00E9lev\u00E9",
    providerRateDesc: "Car le matching fonctionne : haute qualit\u00E9, peu de perte.",
    providerCta: "S'inscrire comme entreprise artisanale",
    principlesTitle: "Pourquoi {{brand}} ?",
    principle1Num: "01",
    principle1Title: "Pas de recherche, pas de comparaison",
    principle1Desc: "Nous ne montrons pas de listes interminables. Notre algorithme s\u00E9lectionne les bonnes entreprises pour vous.",
    principle2Num: "02",
    principle2Title: "Qualit\u00E9 plut\u00F4t que quantit\u00E9",
    principle2Desc: "Maximum 3 \u00E0 5 entreprises par projet. Vous recevez une attention r\u00E9elle.",
    principle3Num: "03",
    principle3Title: "Transparent & \u00E9quitable",
    principle3Desc: "Chacun sait pourquoi un match a \u00E9t\u00E9 \u00E9tabli. Des conditions \u00E9quitables pour les deux parties.",
    statsTitle: "{{brand}} en chiffres",
    stat1Value: "3-5",
    stat1Label: "Entreprises par projet",
    stat2Value: "12+",
    stat2Label: "M\u00E9tiers disponibles",
    stat3Value: "<24h",
    stat3Label: "Temps de r\u00E9ponse",
    stat4Value: "0 \u20AC",
    stat4Label: "Co\u00FBt pour les clients",
    faqLabel: "FAQ",
    faqTitle: "Questions fr\u00E9quentes",
    faqDesc: "R\u00E9ponses pour les clients et les entreprises artisanales.",
    faqForClients: "Pour les clients",
    faqForProviders: "Pour les entreprises",
    faqC1Q: "J'ai besoin d'un artisan, mais je ne sais pas exactement quel métier. CRAFTFINDUS est-il fait pour moi ?",
    faqC1A: "Oui, absolument ! CRAFTFINDUS est conçu exactement pour cela. Décrivez simplement votre projet – nous trouvons le bon métier et les meilleures entreprises pour vous. Entièrement gratuit.",
    faqC2Q: "Combien coûte la recherche d'un artisan ?",
    faqC2A: "Pour vous en tant que client, CRAFTFINDUS est entièrement gratuit. Vous soumettez votre demande de projet, recevez 3 à 5 entreprises artisanales adaptées et décidez vous-même avec qui travailler. Aucun coût caché.",
    faqC3Q: "En combien de temps recevrai-je des réponses à ma demande de projet ?",
    faqC3A: "En général, des entreprises artisanales qualifiées vous contactent dans les 24 heures. Pour les demandes urgentes, souvent encore plus vite. Vous recevez un maximum de 3 à 5 offres – triées sur le volet.",
    faqC4Q: "Quels types de projets puis-je soumettre via CRAFTFINDUS ?",
    faqC4A: "Pratiquement tous les projets artisanaux : électricité, plomberie, chauffage, toiture, aménagement intérieur, photovoltaïque, climatisation, peinture et bien plus encore.",
    faqP1Q: "Qu'est-ce que CRAFTFINDUS m'apporte en tant qu'entreprise artisanale ?",
    faqP1A: "Vous recevez des demandes de projets pré-qualifiées correspondant à votre métier et votre région. Un maximum de 3 à 5 entreprises par demande signifie : moins de concurrence, meilleur taux de conversion.",
    faqP2Q: "Comment fonctionne le matching chez CRAFTFINDUS ?",
    faqP2A: "Notre algorithme analyse chaque demande de projet et la compare à votre profil : métier, spécialisation, région, disponibilité et taille du projet.",
    faqP3Q: "Combien coûte CRAFTFINDUS pour les entreprises artisanales ?",
    faqP3A: "Vous ne payez qu'un prix fixe et transparent par demande de projet acceptée. Pas de frais mensuels, pas de commissions sur vos contrats.",
    faqP4Q: "Qu'est-ce qui distingue CRAFTFINDUS des autres portails d'artisans ?",
    faqP4A: "Pas d'enchères, pas de dumping de prix. Chez CRAFTFINDUS, les entreprises artisanales sont sélectionnées, pas recherchées. La limite de 3 à 5 entreprises par demande garantit des chances équitables.",
    ctaLabel: "Commencer",
    ctaTitle: "Qu'est-ce qui vous correspond ?",
    ctaClientTitle: "Je cherche un artisan",
    ctaClientDesc: "D\u00E9crivez votre projet. Nous trouvons gratuitement les bonnes entreprises pour vous.",
    ctaClientBtn: "Soumettre une demande gratuite",
    ctaProviderTitle: "Je suis une entreprise artisanale",
    ctaProviderDesc: "Recevez des demandes pr\u00E9qualifi\u00E9es correspondant \u00E0 votre profil. Sans ench\u00E8res.",
    ctaProviderBtn: "S'inscrire maintenant",
  },
  auth: {
    seoTitle: "Connexion \u2013 Portail artisanal",
    seoDesc: "Connectez-vous \u00E0 CRAFTFINDUS \u2013 le portail exclusif pour les entreprises artisanales qualifi\u00E9es.",
    backToHome: "Retour \u00E0 l'accueil",
    loginPrompt: "Connectez-vous \u00E0 votre compte",
    emailLabel: "E-mail",
    emailPlaceholder: "votre@email.fr",
    passwordLabel: "Mot de passe",
    passwordPlaceholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
    loginBtn: "Se connecter",
    invalidCredentials: "Identifiants invalides. V\u00E9rifiez vos informations.",
    alreadyRegistered: "Cette adresse e-mail est d\u00E9j\u00E0 enregistr\u00E9e.",
    registrationSuccess: "Inscription r\u00E9ussie ! Confirmez votre e-mail.",
    loginSuccess: "Connect\u00E9 avec succ\u00E8s",
    invalidEmail: "Veuillez entrer une adresse e-mail valide",
    passwordMin: "Le mot de passe doit comporter au moins 6 caract\u00E8res",
  },
  dashboard: {
    title: "Demandes de projets",
    subtitle: "Demandes qualifi\u00E9es pour votre entreprise",
    tabNew: "Nouvelles",
    tabInReview: "En cours",
    tabCompleted: "Termin\u00E9es",
    tabPayment: "Paiement & Facturation",
    tabProfile: "Profil",
    noNew: "Aucune nouvelle demande",
    noInReview: "Aucune demande en cours",
    noCompleted: "Aucune demande termin\u00E9e",
    selectForDetails: "S\u00E9lectionnez une demande\npour les d\u00E9tails",
    weeklyLimitReached: "Limite hebdomadaire atteinte",
    paymentMissing: "Moyen de paiement manquant",
    paymentMissingDesc: "Les demandes ne seront activ\u00E9es qu'apr\u00E8s la configuration du paiement.",
    setupPayment: "Configurer maintenant \u2192",
    paymentRequired: "Veuillez d'abord configurer un moyen de paiement",
    subscriptionBlocked: "Abonnement bloqu\u00E9 \u2013 compl\u00E9tez le paiement",
    quotaExhausted: "Quota atteint \u2013 achetez un add-on ou passez au plan sup\u00E9rieur",
    acceptError: "Erreur lors de l'acceptation",
    accepted: "Demande accept\u00E9e",
    declined: "Demande refus\u00E9e",
    declineError: "Erreur lors du refus",
    questionSent: "Question envoy\u00E9e",
    completed: "Demande termin\u00E9e",
    completeError: "Erreur lors de la cl\u00F4ture",
  },
  onboarding: {
    progressCompany: "Entreprise",
    progressTradesRegion: "M\u00E9tiers & R\u00E9gion",
    progressConfig: "Configuration",
    companyTitle: "Votre entreprise",
    companySubtitle: "Informations de base pour votre profil",
    companyName: "Nom de l'entreprise",
    companyNamePlaceholder: "Votre entreprise artisanale",
    contactPerson: "Personne de contact",
    contactPersonPlaceholder: "Jean Dupont",
    masterCraftsman: "Ma\u00EEtre artisan",
    masterCraftsmanDesc: "Votre entreprise est un atelier de ma\u00EEtre enregistr\u00E9",
    tradesTitle: "Vos m\u00E9tiers",
    tradesSubtitle: "Quels m\u00E9tiers couvrez-vous ?",
    regionTitle: "Votre localisation",
    regionSubtitle: "O\u00F9 se trouve votre entreprise ?",
    regionLabel: "R\u00E9gion / Code postal",
    regionPlaceholder: "p.ex. Paris, 75001",
    radiusTitle: "Rayon d'intervention",
    radiusSubtitle: "Jusqu'o\u00F9 vous d\u00E9placez-vous ?",
    limitTitle: "Limite de demandes",
    limitSubtitle: "Combien de demandes souhaitez-vous par semaine ?",
    limitFocused: "Focalis\u00E9",
    limitStandard: "Standard",
    limitIntensive: "Intensif",
    completeTitle: "Enregistrer le profil",
    summaryCompany: "Entreprise",
    summaryTrades: "M\u00E9tiers",
    summaryMaster: "Ma\u00EEtre artisan",
    summaryRadius: "Rayon",
    summaryLimit: "Limite",
    summaryPerWeek: "par semaine",
    saveProfile: "Enregistrer le profil",
    saving: "Enregistrement...",
    profileCreated: "Profil cr\u00E9\u00E9",
    saveError: "Erreur lors de l'enregistrement",
    veryNear: "Tr\u00E8s proche",
    nearCity: "Proximit\u00E9 ville",
    regional: "R\u00E9gional",
    wide: "Zone \u00E9tendue",
    superRegional: "Super-r\u00E9gional",
  },
  inquiry: {
    seoTitle: "Soumettre une demande \u2013 Trouver des artisans qualifi\u00E9s",
    seoDesc: "Soumettez une demande chez CRAFTFINDUS : Décrivez votre projet et nous trouvons jusqu'à 5 entreprises qualifiées.",
    tradeElektriker: "Électricien",
    tradeSanitaer: "Plomberie",
    tradeHeizung: "Chauffage",
    tradeDachdecker: "Couvreur",
    tradeInnenausbau: "Aménagement intérieur",
    tradeSchreiner: "Menuisier",
    tradeBauunternehmen: "Entreprise de construction",
    tradeFensterbauer: "Installateur de fenêtres",
    tradeGartenbau: "Aménagement paysager",
    tradePhotovoltaik: "Photovoltaïque",
    tradeKlimaanlagen: "Climatisation",
    tradeMalerbetrieb: "Peintre",
    progressDetails: "Détails du projet",
    progressDescription: "Description",
    progressContact: "Contact",
    questionOf: "Question {{current}} sur {{total}}",
    tradeTitle: "De quel m\u00E9tier avez-vous besoin ?",
    tradeSubtitle: "S\u00E9lectionnez le m\u00E9tier appropri\u00E9",
    tradesLoading: "Chargement des m\u00E9tiers...",
    projectTypeTitle: "Type de projet",
    projectTypeSubtitle: "Que faut-il faire ?",
    repair: "R\u00E9paration",
    repairDesc: "R\u00E9parer des dommages existants",
    newBuild: "Construction neuve",
    newBuildDesc: "Nouveau b\u00E2timent ou extension",
    renovation: "R\u00E9novation",
    renovationDesc: "R\u00E9nover l'existant",
    installation: "Installation",
    installationDesc: "Installer un nouveau syst\u00E8me",
    objectTypeTitle: "Type d'objet",
    objectTypeSubtitle: "Quel type de b\u00E2timent ?",
    efh: "Maison individuelle",
    mfh: "Immeuble collectif",
    commercial: "Commercial / Bureau",
    industrial: "Industriel",
    publicBuilding: "B\u00E2timent public",
    urgencyTitle: "Quelle est l'urgence ?",
    urgencySubtitle: "D\u00E9lai pour le d\u00E9but",
    immediate: "Imm\u00E9diatement",
    immediateDesc: "Le plus vite possible",
    oneWeek: "1 semaine",
    oneWeekDesc: "Dans les 7 prochains jours",
    oneMonth: "1 mois",
    oneMonthDesc: "Dans les 30 prochains jours",
    flexible: "Flexible",
    flexibleDesc: "Pas de d\u00E9lai fix\u00E9",
    budgetTitle: "Budget estim\u00E9",
    budgetSubtitle: "Aide au matching",
    under2k: "Moins de 2 000 \u20AC",
    budget2k10k: "2 000 \u00E0 10 000 \u20AC",
    budget10k50k: "10 000 \u00E0 50 000 \u20AC",
    over50k: "Plus de 50 000 \u20AC",
    budgetUnclear: "Pas encore clair",
    descriptionTitle: "D\u00E9crivez votre projet",
    descriptionSubtitle: "Max. 5 000 caract\u00E8res",
    descriptionPlaceholder: "Que faut-il faire ? Des particularit\u00E9s ?",
    desiredStart: "Date de d\u00E9but souhait\u00E9e (optionnel)",
    locationTitle: "O\u00F9 se trouve le projet ?",
    locationSubtitle: "Code postal ou ville",
    contactTitle: "Vos coordonn\u00E9es",
    contactSubtitle: "Pour \u00EAtre contact\u00E9 par les entreprises qualifi\u00E9es",
    contactNameLabel: "Nom *",
    contactNamePlaceholder: "Votre nom",
    contactEmailLabel: "E-mail *",
    contactPhoneLabel: "T\u00E9l\u00E9phone *",
    contactPhonePlaceholder: "+33 ...",
    toSummary: "Aller au r\u00E9capitulatif",
    commitTitle: "Transfert \u00E0 5 entreprises qualifi\u00E9es maximum",
    commitDesc: "Votre demande sera transmise directement aux entreprises correspondantes de votre r\u00E9gion.",
    summaryTrade: "M\u00E9tier",
    summaryProjectType: "Type de projet",
    summaryUrgency: "Urgence",
    summaryLocation: "Localisation",
    summaryBudget: "Budget",
    submitInquiry: "Soumettre la demande",
    submitting: "Envoi en cours...",
    submitSuccess: "Demande soumise avec succ\u00E8s",
    submitError: "Erreur lors de l'envoi",
  },
  thankyou: {
    inquiryTitle: "Votre demande a \u00E9t\u00E9 re\u00E7ue",
    inquiryDesc: "Nous comparons maintenant votre projet avec notre r\u00E9seau d'entreprises qualifi\u00E9es.",
    nextStepsTitle: "Prochaines \u00E9tapes",
    inquiryStep1: "Nous examinons votre demande et trouvons jusqu'\u00E0 5 entreprises.",
    inquiryStep2: "Vous recevez des suggestions par e-mail \u2013 g\u00E9n\u00E9ralement dans les 24 heures.",
    inquiryStep3: "Vous d\u00E9cidez librement avec quelle entreprise discuter.",
    urgentContact: "Pour les questions urgentes, contactez-nous au",
    registrationTitle: "Inscription re\u00E7ue !",
    registrationDesc: "Merci pour votre int\u00E9r\u00EAt pour CRAFTFINDUS.",
    registrationStep1: "Notre \u00E9quipe examine vos informations.",
    registrationStep2: "Apr\u00E8s v\u00E9rification, vous recevrez vos identifiants par e-mail.",
    registrationStep3: "Vous pourrez alors vous connecter et recevoir des demandes imm\u00E9diatement.",
    reviewTime: "La v\u00E9rification prend g\u00E9n\u00E9ralement 1 \u00E0 2 jours ouvrables.",
    contactTitle: "Merci pour votre message",
    contactDesc: "Nous avons re\u00E7u votre demande et vous r\u00E9pondrons dans les plus brefs d\u00E9lais.",
    contactResponse: "Nous r\u00E9pondons g\u00E9n\u00E9ralement dans les 24 heures les jours ouvrables.",
    sendAnother: "Envoyer un autre message",
  },
  contact: {
    seoTitle: "Contact \u2013 Joindre CRAFTFINDUS",
    seoDesc: "Contactez CRAFTFINDUS : Questions sur les demandes, l'inscription ou le partenariat ?",
    title: "Contact",
    desc: "Vous avez des questions sur {{brand}} ou souhaitez nous joindre directement ? Nous attendons votre message.",
    phoneLabel: "T\u00E9l\u00E9phone",
    emailLabel: "E-mail",
    nameLabel: "Nom *",
    namePlaceholder: "Votre nom",
    emailFieldLabel: "E-mail *",
    emailPlaceholder: "votre@email.fr",
    subjectLabel: "Objet *",
    subjectPlaceholder: "De quoi s'agit-il ?",
    messageLabel: "Message *",
    messagePlaceholder: "Votre message...",
    sendBtn: "Envoyer le message",
    sending: "Envoi en cours...",
    sent: "Message envoy\u00E9 !",
    sendFailed: "\u00C9chec de l'envoi. Veuillez r\u00E9essayer plus tard.",
    nameRequired: "Veuillez entrer votre nom",
    emailRequired: "Veuillez entrer une adresse e-mail valide",
    subjectRequired: "Veuillez entrer un objet",
    messageMin: "Le message doit comporter au moins 10 caract\u00E8res",
  },
  about: {
    seoTitle: "\u00C0 propos de CRAFTFINDUS \u2013 Matching artisanal intelligent",
    seoDesc: "CRAFTFINDUS connecte les clients avec des entreprises artisanales qualifi\u00E9es.",
    heroLabel: "\u00C0 propos de {{brand}}",
    heroTitle1: "Les personnes derri\u00E8re",
    heroTitle2: "CRAFTFINDUS.",
    heroDesc: "{{brand}} est n\u00E9 d'une observation simple : Les clients peinent \u00E0 trouver le bon artisan. Et les bons artisans passent trop de temps en prospection.",
    teamLabel: "Notre \u00E9quipe",
    teamTitle: "Les personnes derri\u00E8re",
    founderRole: "Fondateur",
    founderBio1: "En tant qu'entrepreneur de Solingen, je connais les deux c\u00F4t\u00E9s : La frustration des clients et le d\u00E9fi des entreprises artisanales.",
    founderBio2: "{{brand}} est ma r\u00E9ponse \u00E0 ce probl\u00E8me. Une plateforme bas\u00E9e sur le matching intelligent et \u00E9quitable.",
    chrisRole: "Associ\u00E9",
    chrisBio: "Chris apporte une pens\u00E9e strat\u00E9gique et une exp\u00E9rience entrepreneuriale \u00E0 l'\u00E9quipe.",
    veronikaRole: "Assistante de direction & Back-office",
    veronikaBio: "Veronika coordonne tous les processus en arri\u00E8re-plan.",
    dukeRole: "Chien de bureau & Feel-Good Manager",
    dukeBio: "Aucune r\u00E9union sans Duke. Notre Bull Terrier apporte la bonne humeur.",
    valuesLabel: "Nos valeurs",
    valuesTitle: "Ce que nous d\u00E9fendons",
    value1Title: "Qualit\u00E9 avant quantit\u00E9",
    value1Desc: "Nous croyons en moins de connexions, mais meilleures. Chaque demande est limit\u00E9e \u00E0 3 \u00E0 5 entreprises.",
    value2Title: "\u00C9quit\u00E9 pour les deux parties",
    value2Desc: "Gratuit pour les clients, prix fixes transparents pour les entreprises. Pas de frais cach\u00E9s.",
    value3Title: "Simplicit\u00E9",
    value3Desc: "L'artisanat est d\u00E9j\u00E0 assez complexe. Nous rendons le chemin aussi simple que possible.",
    missionLabel: "Notre mission",
    missionTitle: "Le matching artisanal, comme il devrait \u00EAtre",
    missionP1: "Le march\u00E9 de l'artisanat est fragment\u00E9. Des milliers d'entreprises, d'innombrables portails, mais peu d'orientation r\u00E9elle.",
    missionP2: "{{brand}} fait diff\u00E9remment : Nous s\u00E9lectionnons 3 \u00E0 5 entreprises pour chaque demande.",
    missionP3: "Notre objectif : \u00EAtre la premi\u00E8re r\u00E9f\u00E9rence dans la r\u00E9gion DACH.",
    ctaTitle: "Pr\u00EAts \u00E0 nous conna\u00EEtre ?",
    ctaDesc: "Que vous cherchiez un artisan ou souhaitiez recevoir des demandes qualifi\u00E9es : Nous vous attendons.",
    ctaInquiry: "Soumettre une demande",
    ctaContact: "Nous contacter",
  },
  pricing: {
    seoTitle: "Tarifs \u2013 Abonnements pour entreprises artisanales",
    seoDesc: "Plans mensuels transparents pour des demandes qualifi\u00E9es.",
    heroLabel: "Tarifs",
    heroTitle1: "Plus de commandes.",
    heroTitle2: "Moins de temps mort.",
    heroDesc: "Choisissez le plan adapt\u00E9 \u00E0 votre entreprise.",
    leadsIncluded: "leads accept\u00E9s inclus",
    choosePlan: "Choisir un plan",
    mostPopular: "Plan le plus populaire",
    addonsLabel: "Add-ons",
    addonsTitle: "Réserver des leads supplémentaires",
    radiusLabel: "Extensions de rayon",
    radiusTitle: "Étendre votre zone de service",
    radiusDesc: "Élargissez votre rayon de service et recevez des demandes de projet d'une zone plus grande.",
    trustNoContract: "Sans engagement",
    landingLabel: "Tarifs pour les artisans",
    landingTitle: "Plans d'abonnement transparents",
    landingDesc: "Choisissez le plan adapté à votre entreprise – sans frais cachés, sans engagement.",
    landingCta: "Voir tous les plans",
    trustInstant: "Pr\u00EAt imm\u00E9diatement",
    trustVerified: "Uniquement des demandes v\u00E9rifi\u00E9es",
    faqLabel: "Questions fr\u00E9quentes",
    faqTitle: "Questions sur les tarifs",
    ctaTitle: "Pr\u00EAt pour de nouvelles commandes ?",
    ctaDesc: "Inscrivez-vous gratuitement, choisissez votre plan et recevez des demandes correspondantes.",
    ctaBtn: "S'inscrire maintenant",
    faq1q: "Je ne paie qu'\u00E0 l'acceptation ?",
    faq1a: "Non \u2013 avec un abonnement, vous payez un montant mensuel fixe incluant un certain nombre de leads.",
    faq2q: "Que se passe-t-il quand mon quota est \u00E9puis\u00E9 ?",
    faq2a: "Vous pouvez acheter un add-on pour des leads suppl\u00E9mentaires.",
    faq3q: "Puis-je changer de plan ?",
    faq3a: "Oui, vous pouvez upgrader \u00E0 tout moment. Le nouveau plan prend effet imm\u00E9diatement.",
    faq4q: "Y a-t-il un engagement ?",
    faq4a: "Non. Vous pouvez r\u00E9silier votre abonnement \u00E0 tout moment en fin de p\u00E9riode.",
    faq5q: "Qu'a de sp\u00E9cial le plan 'Premium' ?",
    faq5a: "Les entreprises Premium re\u00E7oivent un badge V\u00E9rifi\u00E9 et sont prioritaires.",
  },
  billing: {
    title: "Facturation & Plan",
    subtitle: "G\u00E9rez votre plan, quotas et moyen de paiement",
    tabPlan: "Plan & Facturation",
    tabQuotas: "Quotas",
    tabPayment: "Moyen de paiement",
    statusActive: "Actif",
    statusTrial: "P\u00E9riode d'essai",
    statusPastDue: "Paiement en retard",
    statusBlocked: "Bloqu\u00E9",
    statusCanceled: "R\u00E9sili\u00E9",
    statusPending: "En attente",
    pastDueBanner: "Paiement \u00E9chou\u00E9. Mettez \u00E0 jour votre moyen de paiement.",
    blockedBanner: "Abonnement bloqu\u00E9. Compl\u00E9tez le paiement pour continuer.",
    updatePayment: "Mettre \u00E0 jour le paiement",
    cancelledNotice: "Votre abonnement se termine le {{date}}.",
    cancelSub: "R\u00E9silier l'abonnement",
    cancelConfirm: "Voulez-vous vraiment r\u00E9silier votre abonnement en fin de p\u00E9riode ?",
    cancelSuccess: "L'abonnement sera r\u00E9sili\u00E9 en fin de p\u00E9riode",
    noPlan: "Aucun plan actif",
    noPlanDesc: "Choisissez un plan pour recevoir des demandes qualifi\u00E9es.",
    changePlan: "Changer de plan",
    selectPlan: "Choisir un plan",
    currentPlan: "Actuel",
    activePlan: "Plan actif",
    leadsIncl: "Leads incl.",
    addonsTitle: "Add-ons",
    buy: "Acheter",
    acceptedLeads: "Leads accept\u00E9s",
    deliveries: "Livraisons",
    quotaReached: "Quota atteint \u2013 achetez un add-on ou passez au plan sup\u00E9rieur",
    billingPeriod: "P\u00E9riode de facturation",
    periodResets: "Les quotas sont r\u00E9initialis\u00E9s automatiquement au d\u00E9but de chaque p\u00E9riode.",
  },
  registration: {
    seoTitle: "Inscrire votre entreprise \u2013 Recevoir des demandes qualifi\u00E9es",
    seoDesc: "Inscrivez votre entreprise artisanale chez CRAFTFINDUS : Pr\u00EAt en 15 minutes.",
    title: "S'inscrire comme entreprise artisanale",
    subtitle: "Remplissez le formulaire. Apr\u00E8s v\u00E9rification, vous recevrez vos identifiants par e-mail.",
    requiredFields: "Champs obligatoires : Nom de l'entreprise, personne de contact, e-mail",
    fillRequired: "Veuillez remplir le nom de l'entreprise, la personne de contact et l'e-mail.",
    submitting: "Envoi en cours...",
    submitBtn: "Soumettre l'inscription",
    submitError: "Erreur lors de la soumission",
  },
  handwerker: {
    seoTitle: "Gagner des clients \u2013 Demandes qualifi\u00E9es sans prospection",
    seoDesc: "Gagnez des clients sans prospection : CRAFTFINDUS livre des demandes pr\u00E9qualifi\u00E9es.",
    heroLabel: "Pour les entreprises artisanales",
    heroTitle1: "Demandes qualifi\u00E9es.",
    heroTitle2: "Pas de guerre des prix.",
    heroDesc: "{{brand}} vous livre des demandes de clients qui ont besoin d'un artisan maintenant.",
    registerFree: "S'inscrire gratuitement",
    badgeNoContract: "Sans engagement",
    badgeReady: "Pr\u00EAt en 15 min",
    badgeVerified: "Uniquement des demandes v\u00E9rifi\u00E9es",
    badgePayOnAccept: "Paiement uniquement \u00E0 l'acceptation",
    benefitsLabel: "Vos avantages",
    benefitsTitle: "Pourquoi les entreprises choisissent {{brand}}",
    benefit1Title: "Matching pr\u00E9cis",
    benefit1Desc: "Notre algorithme matche chaque demande avec votre profil.",
    benefit2Title: "Max. 3 \u00E0 5 entreprises par projet",
    benefit2Desc: "Pas de distribution de masse. Moins de concurrence, plus de r\u00E9ussite.",
    benefit3Title: "Prix fixes transparents",
    benefit3Desc: "Vous ne payez que par demande accept\u00E9e \u2013 un prix fixe et transparent.",
    benefit4Title: "Demandes pr\u00E9qualifi\u00E9es",
    benefit4Desc: "Chaque demande est v\u00E9rifi\u00E9e avant de vous \u00EAtre envoy\u00E9e.",
    benefit5Title: "Croissance pr\u00E9visible",
    benefit5Desc: "D\u00E9cidez combien de demandes vous acceptez par mois.",
    benefit6Title: "Acc\u00E8s rapide",
    benefit6Desc: "Inscrivez-vous, cr\u00E9ez votre profil, recevez des demandes. Pr\u00EAt en 15 minutes.",
    pricingLabel: "Exemples de prix",
    pricingTitle: "Prix fixes transparents par demande",
    pricingDesc: "Vous ne payez que pour les demandes que vous acceptez activement.",
    smallProjects: "Petits projets",
    smallExamples: "p.ex. prises \u00E9lectriques, robinets, peinture murale",
    mediumProjects: "Projets moyens & grands",
    mediumExamples: "p.ex. r\u00E9novation de salle de bain, panneaux solaires, r\u00E9novation compl\u00E8te",
    priceFrom: "\u00E0 partir de {{price}} \u20AC",
    perAcceptedInquiry: "par demande accept\u00E9e",
    goodToKnow: "Bon \u00E0 savoir",
    goodToKnow1: "Pas de frais mensuels. Paiement uniquement \u00E0 l'acceptation",
    goodToKnow2: "La taille du projet d\u00E9termine le prix \u2013 visible \u00E0 l'avance",
    goodToKnow3: "R\u00E9clamation en cas de mauvaise qualification \u2013 remboursement garanti",
    goodToKnow4: "Facturation via votre moyen de paiement enregistr\u00E9",
    howLabel: "Comment \u00E7a marche",
    howTitle: "3 \u00E9tapes vers de nouveaux projets",
    step1Title: "Cr\u00E9er votre profil",
    step1Desc: "M\u00E9tier, r\u00E9gion, capacit\u00E9 et sp\u00E9cialisation.",
    step2Title: "Recevoir des demandes",
    step2Desc: "Les projets correspondants vous sont livr\u00E9s automatiquement.",
    step3Title: "Accepter & contacter",
    step3Desc: "Vous d\u00E9cidez quels projets accepter et parlez directement avec le client.",
    startNow: "Commencer maintenant",
    faqLabel: "Questions fr\u00E9quentes",
    faqTitle: "Questions des entreprises",
    ctaTitle: "Pr\u00EAt pour des demandes qualifi\u00E9es ?",
    ctaDesc: "Inscrivez-vous gratuitement et recevez des projets correspondants \u2013 sans engagement.",
    ctaBtn: "S'inscrire gratuitement",
  },
  notFound: {
    title: "Page non trouv\u00E9e",
    description: "La page demand\u00E9e n'existe pas.",
  },
  limitReached: {
    title: "Pause",
    subtitle: "Votre limite hebdomadaire est atteinte.",
    nextReset: "Prochain d\u00E9verrouillage",
    description: "La limite prot\u00E8ge la qualit\u00E9 de la plateforme.",
    adjustLimit: "Ajuster la limite",
  },
  skipLink: "Aller au contenu principal",
  portal: {
    switchPortal: "Changer de portail", profile: "Profil", changePassword: "Changer le mot de passe",
    signOut: "Se déconnecter", newPassword: "Nouveau mot de passe", passwordPlaceholder: "Au moins 6 caractères",
    saving: "Enregistrement...", saveBtn: "Enregistrer", cancelBtn: "Annuler",
  },
  opportunityDetail: {
    company: "Entreprise", confidentialUntilAccept: "Confidentiel jusqu'à acceptation", notSpecified: "Non spécifié",
    urgency: "Urgence", decision: "Décision", matchScore: "Score de match", location: "Emplacement",
    remote: "À distance", remotePossible: "Possible", onsite: "Sur place", compliance: "Conformité",
    complianceRelevant: "Pertinent", onsiteLabel: "Sur place", onsiteRequired: "Requis",
    context: "Contexte", whySelected: "Pourquoi vous avez été sélectionné", inquiryAccess: "Accès à la demande",
    accepting: "Acceptation...", acceptInquiry: "Accepter la demande", decline: "Refuser",
    responseWindow: "Fenêtre de réponse : 2h recommandé", claimLabel: "Réclamation", claimBtn: "Réclamer",
    completed: "Terminé", won: "Gagné", lost: "Perdu", noFit: "Pas de correspondance",
    claimApproved: "Approuvé", claimRejected: "Rejeté", claimUnderReview: "En examen",
    claimSubmitted: "Soumis", submittedAt: "Soumis le", decidedAt: "Décidé le",
    reason: "Motif", rejectionReason: "Motif du rejet", note: "Note",
    expiresIn: "Expire dans {{hours}}h", expired: "Expiré",
  },
  regForm: {
    companyData: "Données de l'entreprise", companyName: "Nom de l'entreprise *", companyNamePlaceholder: "Votre entreprise",
    companyType: "Type d'entreprise", companyTypePlaceholder: "– Sélectionnez –", legalName: "Raison sociale",
    legalNamePlaceholder: "p. ex. selon le registre", contactPerson: "Personne de contact *", contactPersonPlaceholder: "Votre nom",
    role: "Rôle / Poste", rolePlaceholder: "p. ex. Directeur", email: "E-mail *", emailPlaceholder: "votre@email.fr",
    phone: "Téléphone", phonePlaceholder: "+33 ...", website: "Site web", websitePlaceholder: "https://...",
    invoiceEmail: "E-mail de facturation", invoiceEmailPlaceholder: "compta@entreprise.fr",
    address: "Adresse", street: "Rue & numéro", postalCode: "Code postal", city: "Ville", country: "Pays",
    countryDE: "Allemagne", countryAT: "Autriche", countryCH: "Suisse",
    vatId: "N° TVA", vatIdPlaceholder: "FR12345678901",
    contacts: "Contacts", contactsDesc: "Optionnel : Contacts supplémentaires",
    addContact: "Ajouter un contact", noContacts: "Aucun contact supplémentaire",
    createContact: "Créer un contact", contactN: "Contact {{n}}", primaryContact: "Contact principal",
    setPrimary: "Définir comme principal", nameRequired: "Nom *", emailRequired: "E-mail *", rolePlaceholderShort: "p. ex. Ventes",
  },
  stackPicker: { noResults: "Aucune technologie trouvée", addCustom: "Ajouter une technologie", customPlaceholder: "p. ex. SAP, DATEV..." },
  thankyouExtra: { orVia: "ou par", emailLabel: "E-mail" },
  pdExtra: { slaResponseTime: "Temps de réponse SLA" },
  completionDialog: {
    confirmTitle: "Terminer la demande",
    confirmDesc: "La demande est-elle termin\u00E9e et le contact avec le client termin\u00E9 ?",
    confirmYes: "Oui, terminer",
    confirmNo: "Non, retour",
    outcomeTitle: "R\u00E9sultat",
    outcomeDesc: "Une commande a-t-elle \u00E9t\u00E9 pass\u00E9e ?",
    won: "Oui \u2013 Commande obtenue",
    lost: "Non \u2013 Commande perdue",
    noFit: "Pas de fit / Non poursuivi",
  },
  suche: {
    seoTitle: "Trouver un artisan \u2013 gratuit & sans inscription",
    seoDesc: "Trouvez l\u2019artisan adapt\u00E9 : gratuit, sans engagement & conforme au RGPD.",
    trustDach: "\uD83C\uDDE9\uD83C\uDDEA \uD83C\uDDE6\uD83C\uDDF9 \uD83C\uDDE8\uD83C\uDDED R\u00E9gion DACH",
    trustFree: "100% gratuit",
    trustGdpr: "Conforme au RGPD",
    trustConsent: "Aucun partage sans consentement",
    heroTitle: "Trouvez le bon artisan.",
    heroAccent: "Gratuit, sans engagement & sans inscription",
    heroDesc: "Nous trouvons les artisans adapt\u00E9s de votre r\u00E9gion gr\u00E2ce au matching intelligent.",
    heroCta: "Trouver un artisan maintenant",
    heroSubline: "Gratuit \u00B7 Sans engagement \u00B7 R\u00E9ponse sous 24h",
    howBtn: "Comment fonctionne {{brand}} ?",
    howTitle: "Comment fonctionne {{brand}} ?",
    howIntro: "{{brand}} met en relation les ma\u00EEtres d\u2019ouvrage avec des artisans qualifi\u00E9s.",
    howStep1: "Vous d\u00E9crivez votre projet",
    howStep1Desc: "en quelques \u00E9tapes, sans jargon technique.",
    howStep2: "Matching intelligent",
    howStep2Desc: "notre algorithme trouve les artisans adapt\u00E9s de votre r\u00E9gion.",
    howStep3: "Validation humaine",
    howStep3Desc: "chaque correspondance est v\u00E9rifi\u00E9e avant envoi.",
    howStep4: "Jusqu\u2019\u00E0 5 artisans vous contactent",
    howStep4Desc: "personnellement et directement.",
    howFreeTitle: "Enti\u00E8rement gratuit pour vous",
    howFreeDesc: "Les co\u00FBts sont pris en charge par l\u2019artisan.",
    problemsTitle: "Vous connaissez le",
    problemsAccent: "probl\u00E8me",
    problemsSuffix: ". Nous trouvons la solution",
    problemsDesc: "Pas besoin d\u2019expertise. D\u00E9crivez simplement ce qui doit \u00EAtre fait.",
    problem1: "Chauffage en panne ou plomberie n\u00E9cessaire",
    problem2: "Installation \u00E9lectrique ou panneaux solaires pr\u00E9vus",
    problem3: "R\u00E9paration ou r\u00E9fection de toiture",
    problem4: "Am\u00E9nagement int\u00E9rieur, pl\u00E2trerie ou peinture",
    problem5: "Fen\u00EAtres, portes ou fa\u00E7ade \u00E0 renouveler",
    problem6: "Am\u00E9nagement paysager",
    problemsCta: "D\u00E9crivez votre projet maintenant",
    problemsCtaSub: "Aucune expertise requise \u00B7 Processus guid\u00E9",
    stepsTitle: "En 3 \u00E9tapes vers le",
    stepsAccent: "bon artisan",
    stepsDesc: "Voici comment {{brand}} fonctionne pour vous",
    step1Title: "D\u00E9crire le projet",
    step1Desc: "D\u00E9crivez en quelques \u00E9tapes le service artisanal dont vous avez besoin.",
    step2Title: "Nous matchons pour vous",
    step2Desc: "Notre algorithme trouve les artisans adapt\u00E9s de votre r\u00E9gion.",
    step3Title: "Recevoir des devis",
    step3Desc: "Sous 24h, jusqu\u2019\u00E0 5 artisans qualifi\u00E9s vous contactent.",
    stepsBanner: "Enti\u00E8rement gratuit \u00B7 Pas de co\u00FBts cach\u00E9s \u00B7 Pas de commission",
    exampleTitle: "Voici \u00E0 quoi ressemble une",
    exampleAccent: "demande de projet",
    exampleSuffix: "",
    exampleLabel: "Exemple de demande de projet",
    exampleName: "R\u00E9novation compl\u00E8te de salle de bain",
    exampleRegion: "Solingen",
    exampleObject: "Maison individuelle",
    exampleUrgency: "Sous 1 mois",
    exampleMatched: "4 artisans trouv\u00E9s",
    regionLabel: "R\u00E9gion",
    objectLabel: "Objet",
    timeframeLabel: "D\u00E9lai",
    resultLabel: "R\u00E9sultat",
    exampleResult: "En <strong>24 heures</strong>, ce client a re\u00E7u 4 devis adapt\u00E9s.",
    exampleCta: "Soumettre votre propre demande",
    whyTitle: "Pourquoi les clients utilisent {{brand}}",
    why1: "Enti\u00E8rement gratuit, sans frais cach\u00E9s",
    why2: "Traitement des donn\u00E9es conforme au RGPD en Allemagne",
    why3: "Vos donn\u00E9es ne sont partag\u00E9es qu\u2019apr\u00E8s consentement (max. 5)",
    why4: "Artisans s\u00E9lectionn\u00E9s, max. 5 par demande",
    why5: "R\u00E9ponse sous 24 heures",
    why6: "Support personnel pour vos questions",
    whyTrust: "Approuv\u00E9 par des clients de la r\u00E9gion DACH",
    ctaTitle: "Pr\u00EAt \u00E0 trouver le bon",
    ctaAccent: "artisan",
    ctaSuffix: " ?",
    ctaDesc: "D\u00E9crivez votre projet. Nous nous occupons du reste.",
    ctaBtn: "Trouver un artisan maintenant",
    ctaSubline: "Gratuit \u00B7 Sans engagement \u00B7 R\u00E9ponse sous 24h",
    ctaPhone: "Des questions ? Appelez-nous au",
    ctaForCraft: "Pour les artisans \u2192",
    ctaForLeads: "Demandes de projets pour artisans \u2192",
    ctaContact: "Contact \u2192",
  },
  leads: {
    seoTitle: "Recevoir des demandes de projets \u2013 Commandes qualifi\u00E9es",
    seoDesc: "Demandes de projets pr\u00E9qualifi\u00E9es de la r\u00E9gion DACH.",
    trustDach: "\uD83C\uDDE9\uD83C\uDDEA \uD83C\uDDE6\uD83C\uDDF9 \uD83C\uDDE8\uD83C\uDDED R\u00E9gion DACH",
    trustGdpr: "Conforme au RGPD",
    trustMax5: "Max. 5 artisans par demande",
    trustPayOnAccept: "Paiement uniquement \u00E0 l\u2019acceptation",
    trustNoSubs: "Pas d\u2019abonnement",
    trustCancelAnytime: "R\u00E9siliable \u00E0 tout moment",
    heroTitle: "Demandes de projets qualifi\u00E9es de votre r\u00E9gion.",
    heroAccent: "Vous ne payez que si vous acceptez",
    heroDesc: "Pas de prospection. Pas d\u2019abonnement.\nUniquement de vraies demandes de clients DACH.",
    heroCta: "D\u00E9marrer l\u2019inscription gratuite",
    heroSubline: "Sans frais \u00B7 Sans obligation \u00B7 Paiement \u00E0 l\u2019acceptation",
    benefitsTitle: "Vos avantages en tant qu\u2019",
    benefitsAccent: "artisan",
    benefit1Title: "Vraies demandes de projets",
    benefit1Desc: "Demandes pr\u00E9qualifi\u00E9es avec un vrai besoin.",
    benefit2Title: "Contr\u00F4le total",
    benefit2Desc: "Vous d\u00E9cidez quelles demandes accepter.",
    benefit3Title: "Paiement \u00E0 l\u2019acceptation",
    benefit3Desc: "Les co\u00FBts n\u2019apparaissent que lorsque vous acceptez une demande.",
    benefitsCta: "D\u00E9marrer l\u2019inscription gratuite",
    howTitle1: "Simple. Transparent.",
    howAccent: "\u00C9quitable.",
    howDesc: "Comment fonctionne {{brand}} : en trois \u00E9tapes",
    howStep1: "Saisir la demande de projet",
    howStep1Desc: "Un client d\u00E9crit son projet.",
    howStep2: "Matching intelligent",
    howStep2Desc: "Notre algorithme s\u00E9lectionne les artisans qui correspondent vraiment.",
    howStep3: "Vous d\u00E9cidez",
    howStep3Desc: "Vous voyez la demande \u00E0 l\u2019avance et ne payez qu\u2019\u00E0 l\u2019acceptation.",
    howBanner: "Pas d\u2019abo \u00B7 Pas de minimum \u00B7 Pas d\u2019obligation",
    faqQ1: "Que signifie \u00AB demande qualifi\u00E9e \u00BB ?",
    faqA1: "Une demande avec un vrai besoin de projet.",
    faqQ2: "Quand les co\u00FBts apparaissent-ils ?",
    faqA2: "Uniquement lorsque vous acceptez une demande.",
    faqQ3: "Puis-je refuser des demandes ?",
    faqA3: "Oui, \u00E0 tout moment et sans frais.",
    trustTitle: "Pourquoi les artisans",
    trustAccent: "choisissent {{brand}}",
    trust1: "Pas de pr\u00E9paiement",
    trust2: "Infos projet transparentes avant votre d\u00E9cision",
    trust3: "R\u00E9gion & m\u00E9tiers configurables individuellement",
    trust4: "R\u00E9partition \u00E9quitable, pas de surcharge",
    trust5: "Remplacement garanti en cas de mauvaise qualification",
    trustCta: "D\u00E9marrer l\u2019inscription gratuite",
    exampleTitle: "Voici \u00E0 quoi ressemble une",
    exampleAccent: "demande de projet",
    exampleSuffix: "",
    exampleLabel: "Nouvelle demande de projet",
    exampleName: "R\u00E9novation salle de bain maison individuelle",
    exampleMax5: "Cette demande a \u00E9t\u00E9 envoy\u00E9e \u00E0 max. <strong>5 artisans</strong>.",
    exampleCta: "Recevoir de telles demandes",
    regionLabel: "R\u00E9gion",
    tradeLabel: "M\u00E9tier",
    budgetLabel: "Budget",
    urgencyLabel: "Urgence",
    objectLabel: "Objet",
    securityTitle: "La confiance est la",
    securityAccent: "base",
    security1: "Traitement conforme au RGPD en Allemagne",
    security2: "Pas de partage de contacts sans votre consentement",
    security3: "Support personnel & r\u00E8gles claires",
    security4: "Prix transparents par demande",
    securityTrust: "Approuv\u00E9 par des clients pilotes dans la r\u00E9gion DACH",
    ctaTitle: "Pr\u00EAt pour de vraies",
    ctaAccent: "demandes de projets ?",
    ctaDesc: "Inscrivez-vous et d\u00E9cidez quelles demandes accepter.",
    ctaBtn: "D\u00E9marrer l\u2019inscription gratuite",
    ctaSubline: "Sans frais \u00B7 Sans obligation \u00B7 R\u00E9siliable \u00E0 tout moment",
    ctaForCraft: "Avantages pour les artisans \u2192",
    ctaForSearch: "Pour les chercheurs de projets \u2192",
    ctaAbout: "\u00C0 propos de CRAFTFINDUS \u2192",
  },
  feedback: {
    seoThankYou: "Feedback \u2013 Merci",
    thankYouTitle: "Merci !",
    thankYouDesc: "Votre feedback a \u00E9t\u00E9 soumis avec succ\u00E8s.",
    errorTitle: "Erreur",
    invalidLink: "Lien invalide ou expir\u00E9.",
    formTitle: "Votre Feedback",
    formDesc: "\u00C9valuez votre exp\u00E9rience avec <strong>{{provider}}</strong>",
    submitBtn: "Envoyer le feedback",
    submitting: "Envoi en cours\u2026",
    anonymous: "Votre feedback est anonyme pour le prestataire.",
    answerPlaceholder: "Votre r\u00E9ponse\u2026",
  },
  withdraw: {
    seoTitle: "Retirer la demande",
    seoDesc: "Retirez votre demande de projet chez CRAFTFINDUS.",
    loading: "V\u00E9rification du lien\u2026",
    errorTitle: "Lien invalide",
    noToken: "Aucun token fourni.",
    alreadyTitle: "D\u00E9j\u00E0 retir\u00E9e",
    alreadyDesc: "Cette demande a d\u00E9j\u00E0 \u00E9t\u00E9 annul\u00E9e.",
    title: "Retirer la demande",
    confirmQuestion: "Voulez-vous vraiment retirer la demande suivante ?",
    requestNumber: "N\u00B0 de demande",
    category: "Cat\u00E9gorie",
    company: "Entreprise",
    createdAt: "Cr\u00E9\u00E9e le",
    reasonLabel: "Motif",
    reasonPlaceholder: "Pourquoi souhaitez-vous retirer la demande ?",
    reasonMin: "Minimum 5 caract\u00E8res requis",
    warning: "En retirant, tous les artisans assign\u00E9s seront inform\u00E9s et la demande sera annul\u00E9e. Cette action est irr\u00E9versible.",
    submitBtn: "Retirer d\u00E9finitivement la demande",
    submitting: "Retrait en cours\u2026",
    successTitle: "Demande retir\u00E9e",
    successDesc: "Votre demande a \u00E9t\u00E9 annul\u00E9e avec succ\u00E8s.",
    notifiedOne: "{{count}} artisan assign\u00E9 a \u00E9t\u00E9 inform\u00E9.",
    notifiedMany: "{{count}} artisans assign\u00E9s ont \u00E9t\u00E9 inform\u00E9s.",
  },
  profileEdit: {
    title: "Modifier le profil",
    subtitle: "Donn\u00E9es de l\u2019entreprise, adresse, contact, m\u00E9tiers et limites",
    companySection: "Entreprise",
    companyName: "Nom de l\u2019entreprise *",
    companyType: "Type d\u2019entreprise",
    companyTypePlaceholder: "\u2013 Veuillez s\u00E9lectionner \u2013",
    legalName: "Raison sociale",
    legalNamePlaceholder: "ex. Exemple SARL",
    vatId: "N\u00B0 TVA",
    vatIdPlaceholder: "FR12345678901",
    website: "Site web",
    addressSection: "Adresse",
    street: "Rue & num\u00E9ro",
    postalCode: "Code postal",
    city: "Ville",
    country: "Pays",
    contactSection: "Contact principal",
    contactName: "Interlocuteur *",
    contactRole: "R\u00F4le",
    contactRolePlaceholder: "ex. G\u00E9rant",
    contactEmail: "E-mail",
    contactPhone: "T\u00E9l\u00E9phone",
    contactPhonePlaceholder: "+33 ...",
    additionalContacts: "Contacts suppl\u00E9mentaires",
    additionalContactsDesc: "Personnes de contact suppl\u00E9mentaires dans votre entreprise",
    addContact: "Ajouter",
    createContact: "Cr\u00E9er un contact",
    noContacts: "Pas encore de contacts suppl\u00E9mentaires",
    contactLabel: "Contact {{n}}",
    primaryContact: "Contact principal",
    nameRequired: "Nom *",
    emailRequired: "E-mail *",
    tradesSection: "M\u00E9tiers & services",
    tradesLabel: "M\u00E9tiers",
    stackLabel: "Stack technologique",
    stackLoading: "Chargement des tags...",
    limitsSection: "Limite mensuelle",
    monthlyLimit: "Limite mensuelle",
    monthlyLimitDesc: "Nombre max. de demandes de projets par mois que vous souhaitez recevoir.",
    monthlyLimitUnit: "Demandes / mois",
    noProfile: "Aucun profil trouv\u00E9.",
    createProfile: "Cr\u00E9er un profil",
    saved: "Profil enregistr\u00E9",
    saveError: "Erreur lors de l\u2019enregistrement",
    notLoggedIn: "Non connect\u00E9",
    saving: "Enregistrement...",
    saveBtn: "Enregistrer le profil",
  },
  sucheHeader: {
    cta: "Trouver un artisan",
    logoAlt: "CRAFTFINDUS | Trouver un artisan",
  },
  leadsHeader: {
    cta: "Recevoir des demandes",
    ctaTooltip: "Vous d\u00E9cidez quelles demandes accepter",
    logoAlt: "CRAFTFINDUS | Demandes de projets qualifi\u00E9es",
  },
  leadsFooter: {
    imprint: "Mentions l\u00E9gales",
    privacy: "Confidentialit\u00E9",
    contact: "Contact",
    faq: "FAQ",
    forCraft: "Pour les artisans",
    motto: "Trouver \u00B7 Connecter \u00B7 R\u00E9soudre",
  },
  op: {
    loadingPortal: "Chargement du portail op\u00E9rateur...",
    portalLabel: "CRAFTFINDUS Op\u00E9rateur",
    roleLabel: "Op\u00E9rateur",
    ctaNewProvider: "Ajouter une entreprise",
    ctaNewProviderDesc: "Ajouter une entreprise artisanale",
    navDashboard: "Tableau de bord",
    navRegistrations: "Inscriptions",
    navRequests: "Demandes de projets",
    navProviders: "Entreprises artisanales",
    navOpportunities: "Matching de projets",
    navClaims: "R\u00E9clamations",
    navBilling: "Facturation",
    navCosts: "Aper\u00E7u des co\u00FBts",
    navPricing: "Tarification",
    navMatching: "Matching",
    navSettings: "Param\u00E8tres",
    navAudit: "Journal d'audit",
    navSales: "Tableau de bord commercial",
    navROI: "Calculateur ROI",
    navFeedback: "Feedback",
    dashTitle: "Tableau de bord",
    dashSubtitle: "Aper\u00E7u de toutes les activit\u00E9s",
    realtimeActive: "Temps r\u00E9el actif – Les nouvelles demandes sont automatiquement match\u00E9es",
    realtimeConnecting: "Connexion en cours…",
    kpiNew7d: "Nouveaux projets (7j)",
    kpiDelivered7d: "Livr\u00E9s (7j)",
    kpiFailed: "\u00C9chou\u00E9s",
    kpiClaimsOpen: "R\u00E9clamations ouvertes",
    kpiBlocked: "Entreprises bloqu\u00E9es",
    kpiRevenue: "Chiffre d'affaires (mois)",
    liveMatching: "Matching en direct",
    waitingForRequests: "En attente de nouvelles demandes…",
    recentRequests: "Demandes r\u00E9centes",
    noRequests: "Aucune demande disponible",
    openClaims: "R\u00E9clamations ouvertes",
    noOpenClaims: "Aucune r\u00E9clamation ouverte",
    provTitle: "Entreprises",
    provSubtitle: "G\u00E9rer les entreprises artisanales",
    filterAll: "Toutes",
    filterActive: "Actives",
    filterPending: "En attente",
    filterSuspended: "Suspendues",
    filterPastDue: "En retard",
    createProvider: "+ Ajouter une entreprise",
    colProvider: "Entreprise",
    colContact: "Contact",
    colRegion: "R\u00E9gion",
    colStatus: "Statut",
    colBilling: "Facturation",
    colSEPA: "SEPA",
    colMandate: "Mandat",
    colLimit: "Limite",
    colCreated: "Cr\u00E9\u00E9",
    statusActive: "Actif",
    statusPending: "En attente",
    statusSuspended: "Suspendu",
    noProviders: "Aucune entreprise trouv\u00E9e",
    reqTitle: "Demandes de projets",
    reqSubtitle: "Toutes les demandes de projets re\u00E7ues",
    reqDetailTitle: "D\u00E9tails de la demande",
    backToList: "Retour \u00E0 la liste",
    filterUnmatched: "Non match\u00E9es",
    filterMatched: "Match\u00E9es",
    colNumber: "N\u00B0",
    colCategory: "Cat\u00E9gorie",
    colCompany: "Entreprise",
    colUrgency: "Urgence",
    colPrice: "Prix",
    colDate: "Date",
    matched: "Match\u00E9",
    open: "Ouvert",
    catSupport: "Petite r\u00E9paration",
    catManaged: "Contrat de maintenance",
    catProject: "Projet de construction",
    catSecurity: "Service d'urgence",
    catCloud: "R\u00E9novation",
    urgImmediate: "Imm\u00E9diat",
    urgWithin48h: "48 heures",
    urgWithin7d: "7 jours",
    urgPlanned: "Planifi\u00E9",
    decSelf: "Soi-m\u00EAme",
    decTeam: "\u00C9quipe",
    decRecommend: "Recommandation",
    labelCategory: "Cat\u00E9gorie",
    labelUrgency: "Urgence",
    labelRegion: "R\u00E9gion",
    labelRemote: "T\u00E9l\u00E9travail",
    labelOnsite: "Sur site",
    labelCompliance: "Conformit\u00E9",
    labelDecision: "D\u00E9cision",
    labelBudget: "Budget",
    labelPrice: "Prix",
    labelProjectSize: "Taille du projet",
    labelSystems: "Syst\u00E8mes",
    labelUsers: "Utilisateurs",
    labelDescription: "Description",
    labelContext: "Contexte",
    labelStackTags: "Tags de m\u00E9tier",
    labelOpportunities: "Opportunit\u00E9s",
    labelMatchRuns: "Cycles de matching",
    labelRequester: "Demandeur",
    labelRiskFlags: "Indicateurs de risque",
    selected: "s\u00E9lectionn\u00E9",
    startMatching: "D\u00E9marrer le matching",
    matchingRunning: "Matching en cours...",
    matchingStarted: "Matching d\u00E9marr\u00E9",
    matchingFailed: "Matching \u00E9chou\u00E9",
    deleteRequest: "Supprimer la demande",
    deleteRequestTitle: "Supprimer la demande ?",
    deleteRequestDesc: "La demande <strong>{{number}}</strong> et toutes les donn\u00E9es associ\u00E9es seront d\u00E9finitivement supprim\u00E9es.",
    cancelAction: "Annuler",
    deleting: "Suppression en cours...",
    deleteForever: "Supprimer d\u00E9finitivement",
    requestDeleted: "Demande {{number}} supprim\u00E9e",
    deleteError: "Erreur lors de la suppression",
    loadError: "Erreur lors du chargement des demandes",
    requestNotFound: "Demande introuvable",
    regTitle: "Inscriptions",
    regSubtitle: "V\u00E9rifier et g\u00E9rer les inscriptions",
    regFilterPending: "En attente",
    regFilterApproved: "Approuv\u00E9es",
    regFilterRejected: "Rejet\u00E9es",
    regNew: "Nouveau",
    regNoEntries: "Aucune inscription dans cette cat\u00E9gorie",
    regSelect: "S\u00E9lectionner une inscription",
    regApproved: "Inscription approuv\u00E9e – Identifiants en cours de cr\u00E9ation",
    regRejected: "Inscription rejet\u00E9e",
    regCreated: "Inscription cr\u00E9\u00E9e",
    regUpdated: "Inscription mise \u00E0 jour",
    regDeleted: "Inscription supprim\u00E9e",
    regDeleteTitle: "Supprimer l'inscription ?",
    regDeleteDesc: "L'inscription de <strong>{{company}}</strong> sera d\u00E9finitivement supprim\u00E9e.",
    oppTitle: "Matching de projets",
    oppSubtitle: "Surveiller toutes les demandes match\u00E9es",
    filterNew: "Nouveau",
    filterInReview: "En r\u00E9vision",
    filterFailed: "\u00C9chou\u00E9",
    filterHold: "En attente",
    colScore: "Score",
    colDelivery: "Livraison",
    selectOpp: "S\u00E9lectionner une demande",
    resend: "Renvoyer",
    resendTriggered: "Renvoi d\u00E9clench\u00E9",
    labelHoldReason: "Raison de mise en attente",
    labelRequestCompany: "Entreprise (demande)",
    labelRequestEmail: "E-mail (demande)",
    labelLocation: "Localisation",
    claimTitle: "R\u00E9clamations",
    claimSubtitle: "V\u00E9rifier et statuer sur les r\u00E9clamations",
    claimFilterOpen: "Ouvertes",
    claimFilterDecided: "D\u00E9cid\u00E9es",
    claimNone: "Aucune r\u00E9clamation",
    claimSelectDetail: "S\u00E9lectionnez une r\u00E9clamation pour les d\u00E9tails",
    claimDetailTitle: "D\u00E9tail de la r\u00E9clamation",
    claimReason: "Raison",
    claimComment: "Commentaire",
    claimOppPrice: "Prix de l'opportunit\u00E9",
    claimSubmittedAt: "Soumis le",
    claimOperatorNote: "Note op\u00E9rateur",
    claimCredit: "Cr\u00E9dit (centimes)",
    claimApprove: "Approuver",
    claimReject: "Rejeter",
    claimApproved: "R\u00E9clamation approuv\u00E9e",
    claimRejected: "R\u00E9clamation rejet\u00E9e",
    billTitle: "Moniteur de facturation",
    billSubtitle: "Facturation, mandats et statut d'envoi",
    billOverdue: "En retard",
    billMandate: "Moyens de paiement",
    billEmailFailures: "Erreurs e-mail",
    billMonthClose: "Cl\u00F4ture mensuelle",
    billInvoices: "Factures",
    billCloseMonth: "Cl\u00F4turer le mois",
    billClosing: "Cl\u00F4ture en cours...",
    billMonthClosed: "Mois {{month}} cl\u00F4tur\u00E9",
    noEntries: "Aucune entr\u00E9e",
    colOverdueSince: "En retard depuis",
    colMethods: "M\u00E9thodes",
    colOpportunity: "Opportunit\u00E9",
    colError: "Erreur",
    colAttempts: "Tentatives",
    colMonth: "Mois",
    colAmount: "Montant",
    colNet: "Net",
    colGross: "Brut",
    colPeriod: "P\u00E9riode",
    costTitle: "Aper\u00E7u des co\u00FBts",
    costSubtitle: "Demandes accept\u00E9es par entreprise · Facturation mensuelle",
    costProviders: "Entreprises",
    costAccepted: "Demandes accept\u00E9es",
    costTotal: "Montant total ({{month}})",
    costVatNote: "HT · Facturation en fin de mois",
    costNoAccepted: "Aucune demande accept\u00E9e en {{month}}",
    colAccepted: "Accept\u00E9es",
    colAmountNet: "Montant (HT)",
    colAmountGross: "Montant (TTC)",
    costTotalRow: "Total",
    costFooter: "Tous les montants en EUR · TVA 19% · Facturation en fin de mois calendaire",
    auditTitle: "Journal d'audit",
    auditSubtitle: "Protocole d'activit\u00E9 global",
    auditAllEntities: "Toutes les entit\u00E9s",
    auditAllEvents: "Tous les \u00E9v\u00E9nements",
    auditRetention: "R\u00E9tention",
    auditCSV: "Export CSV",
    auditRetentionLabel: "Supprimer automatiquement apr\u00E8s :",
    auditDays: "Jours",
    auditSaved: "R\u00E9tention d\u00E9finie \u00E0 {{days}} jours",
    auditPurgeConfirm: "Supprimer toutes les entr\u00E9es de plus de {{days}} jours maintenant ?",
    auditPurged: "Anciennes entr\u00E9es supprim\u00E9es",
    auditPurgeNow: "Purger maintenant",
    auditCurrentRetention: "Actuellement enregistr\u00E9 : <span>{{days}} jours</span>.",
    colTimestamp: "Horodatage",
    colEvent: "\u00C9v\u00E9nement",
    colEntity: "Entit\u00E9",
    colActor: "Acteur",
    colMeta: "M\u00E9ta",
    auditEntries: "{{count}} entr\u00E9es · Page {{page}} de {{total}}",
    setTitle: "Param\u00E8tres",
    setSubtitle: "Configuration de la plateforme",
    setProviderTemplates: "Mod\u00E8les entreprise",
    setCustomerTemplates: "Mod\u00E8les client",
    setGraph: "Microsoft Graph",
    setUsers: "Gestion des utilisateurs",
    setApiKeys: "Cl\u00E9s API",
    setSaveTemplates: "Enregistrer les mod\u00E8les",
    setTemplatesSaved: "Mod\u00E8les e-mail enregistr\u00E9s",
    setGraphTitle: "Microsoft Graph API",
    setGraphDesc: "Configuration pour l'envoi d'e-mails via Graph API (Mail.Send)",
    setTenantId: "Tenant ID",
    setClientId: "Client ID",
    setClientSecret: "Client Secret",
    setSenderEmail: "E-mail exp\u00E9diteur",
    setRetryPolicy: "Politique de r\u00E9essai",
    setMaxAttempts: "Max. tentatives",
    setIntervals: "Intervalles (min)",
    setIntervalsHint: "S\u00E9par\u00E9s par des virgules, ex. 5,10,30",
    setSaveGraph: "Enregistrer les param\u00E8tres Graph",
    setSavingGraph: "Enregistrement...",
    setGraphSaved: "Param\u00E8tres Microsoft Graph enregistr\u00E9s",
    setTestEmail: "Envoyer un e-mail de test",
    setTestTitle: "Envoyer un e-mail de test",
    setTestDesc: "Entrez l'adresse du destinataire pour un e-mail de test via Microsoft Graph.",
    setTestRecipient: "E-mail du destinataire",
    setTestSending: "Envoi en cours...",
    setTestSend: "Envoyer",
    setTestSent: "E-mail de test envoy\u00E9 \u00E0 {{email}}",
    profTitle: "Mon profil",
    profSubtitle: "Param\u00E8tres personnels et s\u00E9curit\u00E9",
    profAccess: "Acc\u00E8s op\u00E9rateur",
    profDisplayName: "Nom d'affichage",
    profDisplayNamePlaceholder: "Votre nom",
    profSaveName: "Enregistrer le nom",
    profNameSaved: "Nom enregistr\u00E9",
    profChangePassword: "Modifier le mot de passe",
    profNewPassword: "Nouveau mot de passe",
    profNewPasswordPlaceholder: "Au moins 6 caract\u00E8res",
    profConfirmPassword: "Confirmer le mot de passe",
    profConfirmPasswordPlaceholder: "R\u00E9p\u00E9ter le mot de passe",
    profPasswordChanged: "Mot de passe modifi\u00E9 avec succ\u00E8s",
    profPasswordMinLength: "Le mot de passe doit comporter au moins 6 caract\u00E8res",
    profPasswordMismatch: "Les mots de passe ne correspondent pas",
    profAccountDetails: "D\u00E9tails du compte",
    profEmail: "E-mail",
    profCreatedAt: "Compte cr\u00E9\u00E9",
    profLastSignIn: "Derni\u00E8re connexion",
    profSaving: "Enregistrement...",
    pricTitle: "Tarification",
    pricSubtitle: "Abonnements, add-ons et configuration des prix",
    pricPlans: "Abonnements",
    pricAddons: "Add-ons",
    pricPreview: "Aper\u00E7u de la page tarifs",
    pricNewPlan: "Nouveau plan",
    pricEditPlan: "Modifier le plan",
    pricPlanSaved: "Plan enregistr\u00E9",
    pricPlanDeleted: "Plan supprim\u00E9",
    pricDeleteConfirm: "Supprimer le plan ?",
    pricNewAddon: "Nouvel add-on",
    pricEditAddon: "Modifier l'add-on",
    pricAddonSaved: "Add-on enregistr\u00E9",
    pricAddonDeleted: "Add-on supprim\u00E9",
    pricKey: "Cl\u00E9",
    pricName: "Nom",
    pricPriceCents: "Prix (centimes)",
    pricInclLeads: "Leads incl.",
    pricMaxDeliveries: "Max. livraisons",
    pricMaxRadius: "Max. rayon (km)",
    pricMaxTrades: "Max. m\u00E9tiers",
    pricSort: "Tri",
    pricFeaturesJSON: "Fonctionnalit\u00E9s (tableau JSON)",
    pricActiveLabel: "Actif",
    pricInactive: "Inactif",
    pricEdit: "Modifier",
    pricExtraLeads: "Leads suppl\u00E9mentaires",
    matchTitle: "Matching",
    matchSubtitle: "Configuration du moteur de matching",
    matchWeights: "Pond\u00E9ration",
    matchLimits: "Limites & \u00C9quit\u00E9",
    matchAI: "IA Matching",
    matchScoreWeights: "Pond\u00E9ration des scores",
    matchScoreDesc: "R\u00E9partition de 100 points sur les dimensions de matching.",
    matchCurrent: "Actuel :",
    matchStackMatch: "Correspondance m\u00E9tier",
    matchStackMatchDesc: "Correspondance entre le profil de l'entreprise et la demande",
    matchUrgencyFit: "SLA / Urgence",
    matchUrgencyFitDesc: "Temps de r\u00E9ponse SLA vs. urgence de la demande",
    matchGeoFit: "G\u00E9ographie",
    matchGeoFitDesc: "Compatibilit\u00E9 g\u00E9ographique et t\u00E9l\u00E9travail",
    matchReliability: "Fiabilit\u00E9",
    matchReliabilityDesc: "Taux d'acceptation et temps de r\u00E9ponse",
    matchQuality: "Qualit\u00E9",
    matchQualityDesc: "Score de qualit\u00E9 interne de l'entreprise",
    matchLimitsTitle: "Limites & \u00C9quit\u00E9",
    matchLimitsDesc: "Contr\u00F4le de la s\u00E9lection et r\u00E8gles d'\u00E9quit\u00E9",
    matchMaxProviders: "Max. entreprises par demande",
    matchMaxProvidersDesc: "Nombre d'entreprises match\u00E9es par demande",
    matchMinScore: "Seuil de score min.",
    matchMinScoreDesc: "Les entreprises en dessous de ce score sont exclues",
    matchFairnessDelta: "Delta d'\u00E9quit\u00E9",
    matchFairnessDeltaDesc: "Diff\u00E9rence de score pour la rotation \u00E9quitable",
    matchExpiryHours: "D\u00E9lai d'expiration (heures)",
    matchExpiryDesc: "La demande expire apr\u00E8s ce d\u00E9lai",
    matchOverage: "Tol\u00E9rance de d\u00E9passement (%)",
    matchOverageDesc: "= L'entreprise peut d\u00E9passer sa limite mensuelle de {{percent}}%",
    matchOverageExample: "Exemple : Avec une limite de 20 et 20% de tol\u00E9rance, l'entreprise peut accepter jusqu'\u00E0 24 demandes",
    matchSaveConfig: "Enregistrer la configuration",
    matchSaving: "Enregistrement...",
    matchSaved: "Configuration de matching enregistr\u00E9e",
    matchWeightError: "Les poids doivent totaliser 100 (actuellement : {{total}})",
    matchAITitle: "Matching am\u00E9lior\u00E9 par IA",
    matchAIDesc: "Analyse et \u00E9valuation des demandes par IA",
    matchAIModel: "Mod\u00E8le IA",
    matchAIFunctions: "Fonctions IA",
    matchAIEnhanceReasons: "Am\u00E9liorer les justifications",
    matchAIEnhanceReasonsDesc: "L'IA g\u00E9n\u00E8re des explications d\u00E9taill\u00E9es",
    matchAIAdjustScores: "Ajustements de score",
    matchAIAdjustScoresDesc: "L'IA peut ajuster les scores selon l'analyse contextuelle",
    matchAIMaxAdjustment: "Ajustement max. du score (\u00B1)",
    matchAIMaxAdjustmentDesc: "Points maximum que l'IA peut ajouter/soustraire",
    matchAIHowTitle: "Comment fonctionne le matching IA",
    fbTitle: "Feedback",
    fbSubtitle: "G\u00E9rer et envoyer les retours clients",
    fbRequests: "Demandes",
    fbConfig: "Configuration",
    fbWonWithout: "Demandes gagn\u00E9es sans feedback ({{count}})",
    fbSend: "Envoyer",
    fbEmailSent: "E-mail de feedback envoy\u00E9",
    fbAllRequests: "Toutes les demandes de feedback",
    fbNoRequests: "Aucune demande de feedback cr\u00E9\u00E9e.",
    fbResend: "Renvoyer",
    fbEmailResent: "E-mail renvoy\u00E9",
    fbResponses: "R\u00E9ponses",
    fbNoResponses: "Aucune r\u00E9ponse.",
    fbConfigDesc: "Configurez les questions que les clients voient dans le formulaire.",
    fbEditQuestion: "Modifier la question",
    fbNewQuestion: "Créer une nouvelle question",
    fbQuestionText: "Texte de la question",
    fbType: "Type",
    fbTypeRating: "\u00C9toiles",
    fbTypeText: "Texte libre",
    fbTypeYesNo: "Oui/Non",
    fbTypeScale: "\u00C9chelle (1-10)",
    fbSaved: "Enregistr\u00E9",
    salesTitle: "Tableau de bord commercial",
    salesSubtitle: "KPIs et aide \u00E0 l'argumentation",
    salesTotalProviders: "Total entreprises",
    salesActiveProviders: "Entreprises actives",
    salesNewRegs7d: "Nouvelles inscriptions (7j)",
    salesAvgAcceptance: "Taux d'acceptation moy.",
    salesOpps30d: "Opportunit\u00E9s (30j)",
    salesDelivered30d: "Livr\u00E9s (30j)",
    salesRevenue: "Chiffre d'affaires (mois)",
    salesAvgScore: "Score moyen",
    salesElevatorPitch: "Elevator Pitch (30 sec.)",
    salesCopy: "Copier",
    salesCopied: "Copi\u00E9",
    salesTop5: "Top 5 arguments de vente",
    salesArgRiskFree: "Sans risque",
    salesArgRiskFreeDesc: "Pas de contrats, pas de frais de base, paiement uniquement sur acceptation",
    salesArgQuality: "Qualit\u00E9",
    salesArgQualityDesc: "Demandes pr\u00E9-qualifi\u00E9es, matching algorithmique",
    salesArgFairness: "\u00C9quit\u00E9",
    salesArgFairnessDesc: "Max. 3–5 concurrents, pas de guerre des prix",
    salesArgFast: "Rapide",
    salesArgFastDesc: "Inscrit en 15 minutes, premiers leads en heures",
    salesArgFlexible: "Flexible",
    salesArgFlexibleDesc: "Limite hebdomadaire r\u00E9glable, pausable \u00E0 tout moment",
    salesStrongestNumbers: "Les 3 chiffres les plus forts",
    salesAcceptanceRate: "Taux d'acceptation",
    salesResponseTime: "Temps de r\u00E9ponse moy.",
    salesProvidersPerRequest: "Artisans par demande",
    salesObjectionHandling: "Traitement des objections",
    salesBenchmarks: "Benchmarks KPI (pour argumentation)",
    salesKPI: "KPI",
    salesBenchmark: "Benchmark CRAFTFINDUS",
    roiTitle: "Calculateur ROI",
    roiSubtitle: "Calculateur interactif pour les entretiens de vente",
    roiParams: "Ajuster les param\u00E8tres",
    roiLeadsPerMonth: "Leads par mois",
    roiAvgLeadPrice: "Prix moyen du lead (\u20AC)",
    roiConversion: "Taux de conversion Lead \u2192 Client (%)",
    roiAvgDealValue: "Valeur moyenne de commande (\u20AC)",
    roiCurrentCAC: "Co\u00FBt d'acquisition actuel par client (\u20AC)",
    roiIndustryAvg: "Moyenne du secteur : 1 500–3 000 \u20AC",
    roiScenarios: "Sc\u00E9narios rapides",
    roiMonthlyCost: "Co\u00FBts mensuels CRAFTFINDUS",
    roiExpectedCustomers: "Nouveaux clients attendus",
    roiExpectedRevenue: "Chiffre d'affaires attendu",
    roiLabel: "ROI",
    roiCACComparison: "Comparaison des co\u00FBts d'acquisition",
    roiCurrentCACLabel: "CAC actuel",
    roiCraftfindusCAC: "CAC CRAFTFINDUS",
    roiSavingsPerCustomer: "\u00C9conomie par client",
    roiCurrent: "Actuel",
    roiWithCraftfindus: "Avec CRAFTFINDUS",
    roiAnnualSavings: "\u00C9conomie annuelle sur les co\u00FBts d'acquisition",
    roiBasedOn: "Bas\u00E9 sur {{count}} nouveaux clients/an",
    roiTalkingPoint: "Point de discussion",
    pdTabProfile: "Profil & Statut",
    pdTabServices: "Services & Stack",
    pdMasterData: "Donn\u00E9es de base",
    pdContact: "Contact",
    pdPhone: "T\u00E9l\u00E9phone",
    pdWebsite: "Site web",
    pdCompanyType: "Type d'entreprise",
    pdRemote: "T\u00E9l\u00E9travail",
    pdSLA: "SLA",
    pdMonthlyLimit: "Limite mensuelle",
    pdAddress: "Adresse",
    pdResendWelcome: "Renvoyer l'e-mail de bienvenue",
    pdResetPassword: "R\u00E9initialiser le mot de passe",
    pdAdditionalContacts: "Contacts suppl\u00E9mentaires",
    pdStatusActions: "Statut & Actions",
    pdApproved: "Approuv\u00E9",
    pdSuspended: "Suspendu",
    pdSuspendReason: "Raison de suspension :",
    pdSuspendedAt: "Suspendu le :",
    pdFailedDebits: "Pr\u00E9l\u00E8vements \u00E9chou\u00E9s :",
    pdApprove: "Approuver",
    pdSuspend: "Suspendre manuellement",
    pdSuspendPrompt: "Raison de la suspension :",
    pdUnsuspend: "R\u00E9activer",
    pdDelete: "Supprimer",
    pdDeleteTitle: "Supprimer l'entreprise artisanale ?",
    pdDeleteDesc: "<strong>{{company}}</strong> sera d\u00E9finitivement supprim\u00E9.",
    pdDeleted: "Entreprise artisanale supprim\u00E9e",
    pdPayment: "Moyen de paiement (Mollie)",
    pdPaymentStatus: "Statut",
    pdSetupStatus: "Statut de configuration",
    pdMollieCustomer: "Client Mollie",
    pdPaymentMethods: "M\u00E9thodes",
    pdActivateManual: "Activer manuellement",
    pdDeactivateManual: "D\u00E9sactiver manuellement",
    pdPaymentUpdated: "Statut de paiement mis \u00E0 jour",
    pdActionSuccess: "Action {{action}} r\u00E9ussie",
    pdCategories: "Cat\u00E9gories",
    pdNoCategories: "Aucune cat\u00E9gorie attribu\u00E9e",
    pdStack: "Stack / M\u00E9tiers",
    pdNoStack: "Aucun tag stack attribu\u00E9",
    pdAuditLog: "Journal d'activit\u00E9",
    pdNoAuditLog: "Aucune activit\u00E9",
    pcTitle: "Ajouter une entreprise",
    pcSubtitle: "Int\u00E9grer une nouvelle entreprise artisanale",
    pcCreateBtn: "Ajouter l'entreprise",
    pcCreating: "Cr\u00E9ation en cours...",
    pcCreated: "Entreprise artisanale cr\u00E9\u00E9e",
    pcRequiredFields: "Remplir les champs obligatoires (Entreprise, Contact, E-mail)",
    pcLoginRequired: "Fournir l'e-mail de connexion pour l'acc\u00E8s au portail",
    pcCreateError: "Erreur lors de la cr\u00E9ation",
    monthJan: "Janvier",
    monthFeb: "F\u00E9vrier",
    monthMar: "Mars",
    monthApr: "Avril",
    monthMay: "Mai",
    monthJun: "Juin",
    monthJul: "Juillet",
    monthAug: "Ao\u00FBt",
    monthSep: "Septembre",
    monthOct: "Octobre",
    monthNov: "Novembre",
    monthDec: "Décembre",
    regFilterAll: "Toutes",
    regEmpty: "Aucune inscription dans cette catégorie",
    regSelectHint: "Sélectionner une inscription",
    regApproveSuccess: "Inscription approuvée – Identifiants en cours de création",
    regApproveError: "Erreur lors de l'approbation",
    regRejectSuccess: "Inscription rejetée",
    regRejectError: "Erreur lors du rejet",
    regCreateSuccess: "Inscription créée",
    regUpdateSuccess: "Inscription mise à jour",
    regDeleteSuccess: "Inscription supprimée",
    regDeleteError: "Erreur lors de la suppression",
    regDeleteConfirm: "Supprimer définitivement",
    oppFilterNew: "Nouveau",
    oppFilterInReview: "En révision",
    oppFilterFailed: "Échoué",
    oppFilterHold: "En attente",
    oppColNumber: "N°",
    oppColCategory: "Catégorie",
    oppColProvider: "Entreprise",
    oppColScore: "Score",
    oppColStatus: "Statut",
    oppColDelivery: "Livraison",
    oppColPrice: "Prix",
    oppEmpty: "Aucune demande",
    oppSelectHint: "Sélectionner une demande",
    oppResend: "Renvoyer",
    oppResendSuccess: "Renvoi déclenché",
    oppDetailUrgency: "Urgence",
    oppDetailCompany: "Entreprise (demande)",
    oppDetailEmail: "E-mail (demande)",
    oppDetailLocation: "Localisation",
    oppDetailHoldReason: "Raison de mise en attente",
    claimEmpty: "Aucune réclamation",
    claimSelectHint: "Sélectionnez une réclamation pour les détails",
    claimDetail: "Détail de la réclamation",
    claimCreditCents: "Crédit (centimes)",
    claimApproveSuccess: "Réclamation approuvée",
    claimRejectSuccess: "Réclamation rejetée",
    billingTitle: "Moniteur de facturation",
    billingSubtitle: "Facturation, mandats et statut d'envoi",
    billingOverdue: "En retard",
    billingMandate: "Moyens de paiement",
    billingEmailFailures: "Erreurs e-mail",
    billingMonthClose: "Clôture mensuelle",
    billingInvoices: "Factures",
    billingCloseMonth: "Clôturer le mois",
    billingCloseSuccess: "Mois {{month}} clôturé",
    billingEmpty: "Aucune entrée",
    billingOverdueSince: "En retard depuis",
    billingMethods: "Méthodes",
    billingError: "Erreur",
    billingAttempts: "Tentatives",
    billingMonth: "Mois",
    billingAmount: "Montant",
    billingNet: "Net",
    billingGross: "Brut",
    billingPeriod: "Période",
    colBillingStatus: "Statut de facturation",
    profileTitle: "Mon profil",
    profileSubtitle: "Paramètres personnels et sécurité",
    profileRole: "Accès opérateur",
    profileDisplayName: "Nom d'affichage",
    profileNamePlaceholder: "Votre nom",
    profileSaveName: "Enregistrer le nom",
    profileNameSuccess: "Nom enregistré",
    profileNameError: "Erreur lors de l'enregistrement du nom",
    profileChangePassword: "Modifier le mot de passe",
    profileNewPassword: "Nouveau mot de passe",
    profilePasswordPlaceholder: "Au moins 6 caractères",
    profileConfirmPassword: "Confirmer le mot de passe",
    profileConfirmPlaceholder: "Répéter le mot de passe",
    profilePasswordSuccess: "Mot de passe modifié avec succès",
    profilePasswordError: "Erreur lors de la modification du mot de passe",
    profilePasswordMinLength: "Le mot de passe doit comporter au moins 6 caractères",
    profilePasswordMismatch: "Les mots de passe ne correspondent pas",
    profileAccountDetails: "Détails du compte",
    profileEmail: "E-mail",
    profileCreatedAt: "Compte créé",
    profileLastLogin: "Dernière connexion",
    createTitle: "Ajouter une entreprise",
    createSubtitle: "Intégrer une nouvelle entreprise artisanale",
    createSubmit: "Ajouter l'entreprise",
    createSuccess: "Entreprise artisanale créée",
    createError: "Erreur lors de la création",
    createRequiredFields: "Remplir les champs obligatoires (Entreprise, Contact, E-mail)",
    createLoginEmailRequired: "Fournir l'e-mail de connexion pour l'accès au portail",
  },
  aiSearch: {
    title: "Qu'est-ce que CRAFTFINDUS ?",
    definition: "CRAFTFINDUS est une plateforme numérique de qualité pour la mise en relation avec des entreprises artisanales vérifiées en Allemagne, Autriche, Suisse, Pays-Bas, Belgique, France et Pologne. Les donneurs d'ordre décrivent leur projet – CRAFTFINDUS trouve grâce à un matching intelligent 3 à 5 artisans qualifiés et vérifiés dans leur région. Le service est gratuit et sans engagement pour les donneurs d'ordre. Les artisans paient un prix fixe transparent par contact accepté – sans commissions, sans engagement contractuel.",
    highlight1: "Entreprises vérifiées : immatriculation, assurance, solvabilité contrôlées",
    highlight2: "Max. 3–5 entreprises par projet : chances équitables, pas de guerre des prix",
    highlight3: "Prix transparents : prix de contact fixes, pas de frais cachés",
    highlight4: "Processus de réclamation équitable : remboursement pour contacts non qualifiés",
  },
  seoLanding: {
    verified: "Entreprises vérifiées",
    free: "Gratuit & sans engagement",
    fast: "Réponse en 24h",
    ctaRequest: "Soumettre une demande",
    freeForClients: "Gratuit pour les clients",
    whatIsCraftfindus: "Qu'est-ce que CRAFTFINDUS ?",
    whatIsCraftfindusText: "CRAFTFINDUS est une plateforme numérique qui met en relation les clients avec des entreprises artisanales vérifiées en Allemagne, Autriche, Suisse, Belgique, Pays-Bas, France et Pologne. Décrivez votre projet – nous trouvons 3 à 5 entreprises adaptées près de chez vous. Gratuit et sans engagement.",
    verifiedProviders: "{{trade}} vérifiés à {{city}}",
    howItWorks: "Comment fonctionne CRAFTFINDUS",
    costs: "Coûts & prix {{trade}}",
    inCity: "à {{city}}",
    faq: "Questions fréquentes",
    ctaHeading: "{{trade}} à {{city}} recherché ?",
    ctaSubtext: "Soumettez votre demande gratuite et recevez jusqu'à 5 devis d'entreprises vérifiées.",
    relatedCities: "{{trade}} dans d'autres villes",
    otherTrades: "Autres métiers à {{city}}",
    relatedArticles: "Guides associés",
  },
  blog: {
    title: "Guide CRAFTFINDUS",
    description: "Conseils, coûts et guides pour les projets artisanaux",
    noPosts: "Aucun article pour le moment.",
    backToList: "Retour au guide",
  },
  warum: {
    seoTitle: "Pourquoi CRAFTFINDUS – La plateforme qualité pour l'artisanat",
    seoDesc: "Découvrez pourquoi CRAFTFINDUS est différent : contrôle qualité des leads, prix transparents, entreprises vérifiées et processus de réclamation équitable.",
    heroLabel: "Pourquoi CRAFTFINDUS",
    heroTitle1: "Le matching artisanal,",
    heroTitle2: "tel qu'il devrait être.",
    heroDesc: "La plupart des plateformes distribuent des contacts. Nous connectons des projets qualifiés avec des entreprises vérifiées – de manière équitable, transparente et axée sur les résultats.",
    problemLabel: "Le problème du marché",
    problemTitle: "Ce qui ne va pas sur les autres plateformes",
    problem1Title: "Demandes non qualifiées",
    problem1Desc: "Des contacts sans budget, sans vrai projet, sans données vérifiées. Vous payez pour des leads qui ne deviennent jamais des commandes.",
    problem2Title: "Coûts opaques",
    problem2Desc: "Frais cachés, commissions sur les commandes, modèles de prix flous.",
    problem3Title: "Distribution de masse",
    problem3Desc: "Votre demande est envoyée à 10, 15 ou 20 entreprises en même temps. Le résultat : guerre des prix, devis copiés-collés, frustration.",
    problem4Title: "Pas de droit de réclamation",
    problem4Desc: "Contact injoignable ? Mauvais métier ? Pas de chance. Sur la plupart des plateformes, il n'y a pas de solution équitable.",
    solutionLabel: "Notre approche",
    solutionTitle: "Ce que CRAFTFINDUS fait différemment",
    solution1Title: "Score qualité des leads",
    solution1Desc: "Chaque demande est automatiquement évaluée : téléphone vérifié, budget indiqué, description présente. Seules les demandes avec un score > 60 sont facturées.",
    solution2Title: "Prix de contact transparents",
    solution2Desc: "Prix fixes par contact – visibles à l'avance. Pas de commissions, pas de frais cachés.",
    solution3Title: "Max. 3 à 5 entreprises par projet",
    solution3Desc: "Chaque demande est transmise à un maximum de 5 entreprises vérifiées. Moins de concurrence, meilleurs taux de conversion.",
    solution4Title: "Processus de réclamation équitable",
    solution4Desc: "Contact injoignable ? Mauvais métier ? Vous récupérez votre prix de contact – sous 72 heures, garanti.",
    solution5Title: "Entreprises vérifiées",
    solution5Desc: "Inscription au registre du commerce, assurance, solvabilité – nos entreprises passent un processus de vérification en plusieurs étapes.",
    solution6Title: "Mécanisme d'équité",
    solution6Desc: "Détection automatique des abus, tableau de bord de transparence et taux de réclamation maximum protègent la qualité de la plateforme.",
    ctaTitle: "Convaincu ?",
    ctaClientBtn: "Démarrer votre projet professionnellement",
    ctaProviderBtn: "Obtenir plus de projets qualifiés",
  },
  inquiryPsych: {
    qualityHint: "Plus vos informations sont précises, meilleures seront les entreprises que vous recevrez.",
    timePromise: "Prend moins de 2 minutes",
    matchingHint: "Nous vérifions votre demande avant de la transmettre aux entreprises adaptées.",
    descShort: "Veuillez décrire votre projet plus en détail.",
    descGood: "Excellente description – cela augmente vos chances de recevoir des devis rapidement.",
    photoHint: "Les photos aident à une évaluation précise.",
  },
  quality: {
    seoTitle: "Promesse de qualité – Comment fonctionne CRAFTFINDUS",
    seoDesc: "Découvrez de manière transparente comment nous vérifions les projets, contrôlons les entreprises, facturons équitablement et traitons les réclamations.",
    heroLabel: "Notre promesse de qualité",
    heroTitle1: "Transparence.",
    heroTitle2: "Pas seulement une promesse.",
    heroDesc: "Nous vous expliquons exactement comment notre plateforme fonctionne – de la vérification des projets à la réclamation.",
    sec1Title: "Comment les projets sont vérifiés",
    sec1Desc: "Chaque demande passe par notre moteur de qualité automatique. Seules les demandes avec un score d'au moins 60 points sont transmises.",
    sec1Item1: "Numéro de téléphone vérifié (+20 points)",
    sec1Item2: "Budget indiqué (+25 points)",
    sec1Item3: "Description du projet vérifiée (+10 points)",
    sec1Item4: "Coordonnées complètes (+10 points)",
    sec2Title: "Comment les entreprises sont vérifiées",
    sec2Desc: "Nos entreprises passent un processus de vérification en plusieurs étapes. Seules les entreprises vérifiées reçoivent des demandes.",
    sec2Item1: "Inscription au registre du commerce vérifiée (Niveau 1)",
    sec2Item2: "Assurance responsabilité civile vérifiée (Niveau 2)",
    sec2Item3: "Vérification de solvabilité réussie (Niveau 3)",
    sec2Item4: "Vérification d'identité terminée (Niveau 3)",
    sec3Title: "Comment fonctionne la facturation",
    sec3Desc: "Des coûts transparents et prévisibles. Pas de frais cachés, pas de commissions.",
    sec3Item1: "Prix fixes par contact – visibles à l'avance",
    sec3Item2: "Modèles flexibles : Flex, Professional, Premium",
    sec3Item3: "Facturation mensuelle, résiliable à tout moment",
    sec4Title: "Comment fonctionnent les réclamations",
    sec4Desc: "Processus équitable pour les plaintes légitimes. Remboursement sous 72 heures.",
    sec4Item1: "Réclamation directement dans le tableau de bord",
    sec4Item2: "Motifs : Injoignable, mauvais métier, pas un vrai projet",
    sec4Item3: "Les réclamations légitimes sont remboursées immédiatement",
    ctaTitle: "Encore des questions ?",
    ctaDesc: "Contactez-nous ou commencez directement – nous incarnons transparence et équité.",
    ctaClientBtn: "Démarrer votre projet professionnellement",
    ctaProviderBtn: "Obtenir plus de projets qualifiés",
  },
};

export default fr;
